import { render, staticRenderFns } from "./addEventModal.vue?vue&type=template&id=b56e6b9e&scoped=true"
import script from "./addEventModal.vue?vue&type=script&lang=js"
export * from "./addEventModal.vue?vue&type=script&lang=js"
import style0 from "./addEventModal.vue?vue&type=style&index=0&id=b56e6b9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56e6b9e",
  null
  
)

export default component.exports